import React, { useCallback, useMemo } from 'react'
import { DragObjectWithType } from 'react-dnd'
import { Grid as GridModel } from '../../models'
import Grid from '../grid'
import FreeCell from './FreeCell'
import getBounds from './getBounds'
import PlacedTile from './PlacedTile'

export interface TileGridProps<T> {
    grid: GridModel
    margin: number
    isMyTurn: boolean
    onPlace?: (x: {row: number, col: number, tile: T}) => any
}

export default function TileGrid<T extends DragObjectWithType>({
    grid,
    margin,
    isMyTurn,
    onPlace,
}: TileGridProps<T>) {  
    const { minRow, maxRow, minCol, maxCol, isEmpty } = useMemo(() => {
        return getBounds(grid, margin)
    }, [grid, margin])

    const handlePlace = useCallback((x) => onPlace && onPlace(x), [onPlace])
    
    const renderCell = useCallback((row, col) => {
        const tile = ((grid || {})[row] || {})[col]
        const suggest = isMyTurn && isEmpty && row === 0 && col === 0
        if (tile) {
            return <PlacedTile {...tile} />
        }
        return (
            <FreeCell<T>
                row={row}
                col={col}
                suggest={suggest}
                onPlace={({ tile }) => handlePlace({ row, col, tile })}
            />
        )
    }, [grid, isMyTurn, handlePlace, isEmpty])

    return (
        <Grid
            minRow={minRow-margin}
            maxRow={maxRow+margin}
            minCol={minCol-margin}
            maxCol={maxCol+margin}
            renderCell={renderCell}
        />
    )
}